import AssociationInformationForm from './AssociationInformationForm.component';

export default AssociationInformationForm;